export default __webpack_public_path__ + "static/media/truck-driver.a211ee22.png";